import { render, staticRenderFns } from "./createTransactionSettlement.vue?vue&type=template&id=760cbbe2"
import script from "./createTransactionSettlement.vue?vue&type=script&lang=js"
export * from "./createTransactionSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports